/* ============================================================
   TEPORA — interacciones (vanilla JS, sin librerías)
   ============================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveals al hacer scroll ---- */
  function initReveals() {
    var els = document.querySelectorAll(".tp-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("tp-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("tp-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var gallery = document.querySelector("[data-tp-gallery]");
    if (!gallery) return;
    var mainImg = gallery.querySelector("[data-tp-main] img");
    var thumbs = gallery.querySelectorAll("[data-tp-thumb]");
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-tp-full");
        if (!full) return;
        mainImg.style.opacity = "0";
        setTimeout(function () {
          mainImg.src = full;
          mainImg.style.opacity = "1";
        }, 150);
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---- Variantes de producto ---- */
  function initVariants() {
    var root = document.querySelector("[data-tp-product]");
    if (!root) return;
    var dataEl = root.querySelector("[data-tp-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var swatches = root.querySelectorAll("[data-tp-swatch]");
    var idInput = root.querySelector("[data-tp-variant-id]");
    var priceNow = root.querySelector("[data-tp-price-now]");
    var priceOld = root.querySelector("[data-tp-price-old]");
    var addBtn = root.querySelector("[data-tp-add]");
    var chosenLabel = root.querySelector("[data-tp-chosen]");
    if (!swatches.length) return;

    var selected = {};
    // opción única "Color"
    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var k = 0; k < v.options.length; k++) {
          if (selected[k] && selected[k] !== v.options[k]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function money(cents) {
      return (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceOld) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceOld.textContent = money(v.compare_at_price);
          priceOld.style.display = "";
        } else {
          priceOld.style.display = "none";
        }
      }
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute("data-tp-add-label") || "Añadir al carrito";
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute("data-tp-sold-label") || "Agotado";
        }
      }
      if (chosenLabel && v.options && v.options.length) chosenLabel.textContent = v.options[v.options.length - 1];
      updatePackPrices(root, v.price);
    }

    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        var idx = parseInt(sw.getAttribute("data-tp-opt-index"), 10) || 0;
        var val = sw.getAttribute("data-tp-value");
        selected[idx] = val;
        root.querySelectorAll('[data-tp-swatch][data-tp-opt-index="' + idx + '"]').forEach(function (s) {
          s.classList.remove("is-active");
        });
        sw.classList.add("is-active");
        update();
      });
    });

    // preselección: la primera swatch de cada opción
    var seen = {};
    swatches.forEach(function (sw) {
      var idx = parseInt(sw.getAttribute("data-tp-opt-index"), 10) || 0;
      if (!seen[idx]) {
        seen[idx] = true;
        selected[idx] = sw.getAttribute("data-tp-value");
        sw.classList.add("is-active");
      }
    });
    update();
  }

  /* ---- Packs (1 / 2 unidades) ---- */
  function fmtMoney(cents) {
    return (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }

  // El % se lee del propio marcado, así lo que se pinta siempre coincide
  // con lo que el comerciante haya puesto en el editor de temas.
  function packDiscount(root) {
    var tag = root.querySelector('[data-tp-pack][data-tp-qty="2"] .tp-pack__name em');
    if (!tag) return 15;
    var n = parseInt(tag.textContent.replace(/[^0-9]/g, ""), 10);
    return isNaN(n) ? 15 : n;
  }

  function updatePackPrices(root, unitPrice) {
    var el1 = root.querySelector('[data-tp-pack-price="1"]');
    var el2 = root.querySelector('[data-tp-pack-price="2"]');
    if (!el1 && !el2) return;
    var total2 = Math.round((unitPrice * 2 * (100 - packDiscount(root))) / 100);
    if (el1) el1.textContent = fmtMoney(unitPrice);
    if (el2) el2.textContent = fmtMoney(total2);
    var save = root.querySelector("[data-tp-pack-save]");
    if (save) save.textContent = "Ahorras " + fmtMoney(unitPrice * 2 - total2);
  }

  function initPacks() {
    var root = document.querySelector("[data-tp-product]");
    if (!root) return;
    var packs = root.querySelectorAll("[data-tp-pack]");
    var qtyInput = root.querySelector("[data-tp-qty-input]");
    if (!packs.length || !qtyInput) return;
    packs.forEach(function (pack) {
      pack.addEventListener("click", function () {
        packs.forEach(function (other) { other.classList.remove("is-active"); });
        pack.classList.add("is-active");
        qtyInput.value = pack.getAttribute("data-tp-qty") || "1";
      });
    });
  }

  function boot() {
    initReveals();
    initGallery();
    initVariants();
    initPacks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
